import React, { Component } from 'react';
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { EvaluationService } from "src/services";
import { PageLoading } from "src/components";

class PDFChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            options1: {
                chart: {
                    id: "radar-chart",
                    toolbar: {
                        show: false,
                        tools: {
                            download: false,
                        }
                    }
                },
                xaxis: {
                    categories: []
                },
                plotOptions: {
                    radar: {
                      polygons: {
                        strokeColors: '#000000',
                        strokeWidth: 1,
                        connectorColors: '#000000',
                        fill: {
                          colors: undefined
                        }
                      }
                    }
                  }
            },
            options2: {
                chart: {
                  id: "radar-chart2",
                  type: 'bar',
                  height: 350,
                  stacked: true,
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                responsive: [{
                  breakpoint: 480,
                  options: {
                    legend: {
                      position: 'bottom',
                      offsetX: -10,
                      offsetY: 0
                    }
                  }
                }],
                plotOptions: {
                  bar: {
                    horizontal: false,
                    borderRadius: 10
                  },
                },
                xaxis: {
                  type: 'datetime',
                  categories: ['01/01/2011 GMT', '01/02/2011 GMT', '01/03/2011 GMT', '01/04/2011 GMT',
                    '01/05/2011 GMT', '01/06/2011 GMT'
                  ],
                },
                legend: {
                  position: 'right',
                  offsetY: 40
                },
                fill: {
                  opacity: 1
                }
              },
            series: [
                {
                    name: 'Rating',
                    data: [],
                }
            ],
            series2: undefined
        };
    }

    componentWillMount() {
        this.renderMyData();
    }
    

    renderMyData(){
        EvaluationService.GetReportChartData(this.props.id).then(
            (resp) => {
                this.setState({
                    options1: {
                        chart: {
                            id: "radar-chart",
                            toolbar: {
                                show: false,
                                tools: {
                                    download: false
                                }
                            },
                        },
                        yaxis:{
                            show: false,
                            min: 0,
                            max: 4,
                            tickAmount: 4,
                            labels: {
                                show: false,
                              }
                        },
                        xaxis: {
                           categories: resp.chart1Categories,
                           labels: {
                                show: true,
                                style: {
                                  colors: ["#000","#000","#000","#000","#000","#000","#000","#000","#000","#000"],
                                  fontSize:'30px',
                                  fontFamily: 'DBHeavent,THSarabunNew !important'
                                }
                              }
                        },
                        plotOptions: {
                            radar: {
                              polygons: {
                                strokeColors: undefined,
                                strokeWidth: 1,
                                connectorColors: undefined,
                                fill: {
                                  colors: undefined
                                }
                              }
                            }
                          },
                          dataLabels: {
                            enabled: true,
                            background: {
                              enabled: true,
                              borderRadius:2,
                              padding: 20,
                            },
                            style: {
                              fontSize: '25px',
                              fontFamily: 'DBHeavent,THSarabunNew !important',
                              fontWeight: 'bold',
                              colors: undefined
                            },
                            formatter: function (val, opts) {
                              return val.toFixed(2)
                            },
                        }
                    },
                  options2: {
                    chart: {
                      id: "radar-chart3",
                      type: 'bar',
                      stacked: true,
                      toolbar: {
                        show: false
                      }
                    },
                    legend: { show: false },
                    colors: [function ({ value, seriesIndex,dataPointIndex, w }) {
                      var test = w.config.series[seriesIndex].data[dataPointIndex];
                      if(test === value){
                        if (seriesIndex === 0 && dataPointIndex === 0) {
                          return '#434343'
                        } else if (seriesIndex === 1 && dataPointIndex === 0) {
                          return '#666666'
                        } else if (seriesIndex === 2 && dataPointIndex === 0) {
                          return '#999999'
                        } else if (seriesIndex === 3 && dataPointIndex === 0) {
                          return '#b7b7b7'
                        } else if (seriesIndex === 4 && dataPointIndex === 0) {
                          return '#cccccc'
                        } else if (seriesIndex === 0 && dataPointIndex === 1) {
                          return '#073763'
                        } else if (seriesIndex === 1 && dataPointIndex === 1) {
                          return '#0b5394'
                        } else if (seriesIndex === 2 && dataPointIndex === 1) {
                          return '#3d85c6'
                        } else if (seriesIndex === 3 && dataPointIndex === 1) {
                          return '#6d9eeb'
                        } else if (seriesIndex === 4 && dataPointIndex === 1) {
                          return '#9fc5e8'
                        } else if (seriesIndex === 0 && dataPointIndex === 2) {
                          return '#274e13'
                        } else if (seriesIndex === 1 && dataPointIndex === 2) {
                          return '#38761d'
                        } else if (seriesIndex === 2 && dataPointIndex === 2) {
                          return '#6aa84f'
                        } else if (seriesIndex === 3 && dataPointIndex === 2) {
                          return '#93c47d'
                        } else if (seriesIndex === 4 && dataPointIndex === 2) {
                          return '#d9ead3'
                        } else if (seriesIndex === 0 && dataPointIndex === 3) {
                          return '#783f04'
                        } else if (seriesIndex === 1 && dataPointIndex === 3) {
                          return '#b45f06'
                        } else if (seriesIndex === 2 && dataPointIndex === 3) {
                          return '#e69138'
                        } else if (seriesIndex === 3 && dataPointIndex === 3) {
                          return '#f6b26b'
                        } else if (seriesIndex === 4 && dataPointIndex === 3) {
                          return '#f9cb9c'
                        } else if (seriesIndex === 0 && dataPointIndex === 4) {
                          return '#7f6000'
                        } else if (seriesIndex === 1 && dataPointIndex === 4) {
                          return '#bf9000'
                        } else if (seriesIndex === 2 && dataPointIndex === 4) {
                          return '#f1c232'
                        } else if (seriesIndex === 3 && dataPointIndex === 4) {
                          return '#ffd966'
                        } else if (seriesIndex === 4 && dataPointIndex === 4) {
                          return '#ffe599'
                        }
                        else{
                          return '#919191'
                        }
                      }
                      else{
                        return '#434343';
                      }
                    }],
                   
                    plotOptions: {  
                      bar: {
                        horizontal: false,
                        borderRadius: 0,
                      },
                    },
                    dataLabels: {
                      enabled: true,
                      formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                        var section = w.config.series[seriesIndex].label[dataPointIndex];
                        var showData = w.config.series[seriesIndex].showData[dataPointIndex];
                        return [section, showData.toFixed(2)];
                      },
                      style: {
                        colors: ['#fff'],
                        fontSize: '16px',
                        fontFamily: 'DBHeavent,THSarabunNew !important'
                      },
                      textAnchor: 'middle',
                      offsetX: 0,
                      offsetY: 17,
                    },
                    xaxis: {
                      categories: ['A', 'B', 'C', 'D', 'E'],
                    },
                    yaxis: {
                      min: 0,
                      max: 4,
                      labels: {
                        formatter: function (val) {
                          return val.toFixed(0.00);
                        }
                      }
                    },
                    title: {
                      text: 'ESG Score 3.04',
                      offsetY: 390,
                      align: 'center',
                      style: {
                        color: '#000',
                        fontSize: '30px !important',
                        fontFamily: 'DBHeavent,THSarabunNew !important'
                      }
                    },
                    fill: {
                      opacity: 1
                    }
                  },
                  series: [
                    {
                      name: 'Rating',
                      data: resp.chart1Score,
                    }
                  ],
                  series2: resp.chart2Series
                })

                const ID = this.props.id;
                var chart1 = "";
                var chart2 = "";
                window.setTimeout(function() {
                    ApexCharts.exec("radar-chart", "dataURI").then(({ imgURI }) => {
                        
                        chart1 = imgURI;

                        ApexCharts.exec("radar-chart3", "dataURI").then(({ imgURI }) => {

                            chart2 = imgURI;

                            EvaluationService.GetReport(ID, chart1, chart2).then(
                                (response) => {
                                    const url = window.URL.createObjectURL(new Blob([response]));
    
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.setAttribute('download', 'file.pdf');
                                    document.body.appendChild(link);
                                    link.click();
                                   
                                    window.opener = null;
                                    window.open("", "_self");
                                    window.close();
                                }
                            );
                        });
                    });
                }, 2000)
            }
        );
    }

	render() {
            document.body.classList.add('hiddenScroll');
            if(this.state.series2 == undefined)
                return <div>
                    <PageLoading open={true} />
                    </div>;
     		return (
                    <div>
                        <PageLoading open={true} />
                        <div style={{ height: '1000px' }}>&nbsp;</div>
                        <div id="chart">
                        </div>
                        <div >
                            <Chart
                                id="radar-chart"
                                options={this.state.options1}
                                series={this.state.series}
                                type="radar"
                            />
                        </div>
                        <div style={{width:'700px'}}>
                            <Chart
                                id="radar-chart-"
                                options={this.state.options2}
                                series={this.state.series2}
                                type="bar"
                            />
                        </div>
                    </div>
		);
	}
}

export default PDFChart;